export default __webpack_public_path__ + "static/media/radar_opened.6c473cf0.wav";